import { Button } from "@repo/shad/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@repo/shad/ui/card"
import { IconChevronLeft } from "@tabler/icons-react"
import { Link, createFileRoute } from "@tanstack/react-router"

import { PacketAssemblyStartForm } from "../../../components/deal-packets/packet-assembly-start-form"

export const Route = createFileRoute("/$dealership/deal-packets/new")({
  staticData: { breadcrumb: "New Deal" },
  component: NewDealPage,
})

function NewDealPage() {
  const { dealership, stores } = Route.useRouteContext()
  if (!dealership) return null

  return (
    <div className="container mx-auto max-w-lg space-y-6 p-6">
      <div>
        <Button asChild variant="ghost" size="sm" className="mb-3">
          <Link to="/$dealership/deal-packets" params={{ dealership: dealership.slug }}>
            <IconChevronLeft className="mr-2 size-4" />
            Back to deal signing
          </Link>
        </Button>
        <h1 className="text-2xl font-semibold tracking-tight">Packet Assembly</h1>
        <p className="text-muted-foreground mt-1">
          Start with the packet, then continue into the draft to fill in deal details.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Start assembly</CardTitle>
          <CardDescription>
            Choose a preset or build a custom packet before the draft is created.
          </CardDescription>
        </CardHeader>
        <CardContent className="p-0">
          <PacketAssemblyStartForm stores={stores} dealershipSlug={dealership.slug} />
        </CardContent>
      </Card>
    </div>
  )
}
